import React from 'react';
import * as Ark from '@dateam/ark';
import { useVarietals } from 'data/varietal';
import {
    QueryResult,
    queryResultKeys
} from '../constants';

export type VarietalTypeSearchFilter = {
    code: string | undefined;
    label: string | undefined;
};

export const useVarietalTypeSearch = (
    filter: VarietalTypeSearchFilter,
    options?: DataOptions
): QueryResult<App.VarietalType[]> => {
    const { data: varietalTypes, ...queryResult } = useVarietals();

    return React.useMemo(() => {
        let filteredData: App.VarietalType[] = [];

        if (Ark.isArray(varietalTypes)) {
            filteredData = [...varietalTypes];

            const {
                label: userLabelFilter,
                code: userCodeFilter
            } = filter;

            const filterPredicates: ((dataEntry: App.VarietalType) => boolean)[] = [];

            if (Ark.isString(userLabelFilter) && userLabelFilter.trim().length > 0) {
                const filter = userLabelFilter.trim().toUpperCase();
                filterPredicates.push((dataEntry: App.VarietalType) =>
                    dataEntry.label.toUpperCase().indexOf(filter) >= 0);
            }

            if (Ark.isString(userCodeFilter) && userCodeFilter.trim().length > 0) {
                const filter = userCodeFilter.trim().toUpperCase();
                filterPredicates.push((dataEntry: App.VarietalType) =>
                    dataEntry.code.toUpperCase().indexOf(filter) >= 0);
            }

            filteredData = filteredData.filter(dataEntry => filterPredicates.every(predicate => predicate(dataEntry)));
        }

        Ark.orderBy(filteredData, 'code');

        const result = {
            ...queryResult,
            data: filteredData
        };

        return Ark.objectPick(result as any, queryResultKeys);
    }, [varietalTypes, queryResult, filter]);
};
